"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiFeature = void 0;
var AiFeature;
(function (AiFeature) {
    AiFeature["AiChat"] = "ai_chat";
    AiFeature["CustomValidation"] = "custom_validation";
})(AiFeature || (exports.AiFeature = AiFeature = {}));
//# sourceMappingURL=ai-feature.js.map